import React, { useState, useEffect } from 'react';
import ShowModal from '../../../../Common/Modal/modal';
import VistaTable from '../../../../Common/Table/VistaTable';
import { NotificationForm } from './notificationForm';
import NotificationService from './notificationService';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle , faSearch} from '@fortawesome/free-solid-svg-icons';
import DeleteCell from '../../../../Common/Table/DeleteCell';


export function NotificationList(props) {
    const [showModal, setShowModal] = useState(false);
    const [data, setNotificationListData] = useState([]);
    const {
        customerData: { customerId },
    } = props;
    const [notificationSer] = useState(new NotificationService());

    useEffect(() => {
        (async () => {
            setNotificationListData(await notificationSer.getAllCompanyPreferences(customerId));
        })();
    }, []);


    const notificationListcolumns = [
        {
            Header: 'Email Address',
            accessor: 'email',
            Filter: ({filter, onChange}) => filterRender(filter, onChange),
        },
        {
            Header: 'Notification Preference',
            accessor: 'preference',
            Filter: ({filter, onChange}) => filterRender(filter, onChange),
        },
        {
            Header: () => <div style={{ textAlign: 'center' }}>Remove</div>,
            Cell: DeleteCell,
            getProps: (state, rowInfo) => ({
                onClick: () => {
                    notificationSer.deleteCompanyPreferences(rowInfo.original.id);
                    getAllCompanyPreferences();
                },
            }),
            className: 'td-button-outer',
            minWidth: 110,
            filterable: false
        },
    ];

    const toggleModel = () => {
        setShowModal(!showModal);
    };

    const addNotificationList = () => {
        setShowModal(!showModal);
    };

   const getAllCompanyPreferences = async() => {
        setNotificationListData(await notificationSer.getAllCompanyPreferences(customerId));
    };


    return (
        <div className="model-list-box">
            <div>
                {showModal ? (
                    <ShowModal
                        toggleModel={toggleModel}
                        show={showModal}
                        title="Add Notification Preference"
                        renderModalBody={
                            <NotificationForm
                                customerId={customerId}
                                setNotificationListData={setNotificationListData}
                                toggleModel={toggleModel}
                                data={data}
                            />
                        }
                    />
                ) : null}
            </div>
            <Button className="add-preference-btn text-center btn-sm" onClick={addNotificationList}>
                <FontAwesomeIcon className="btn-icon" icon={faPlusCircle} />
                <span className='add-preference-span'>Add Preference</span>
            </Button>
            <VistaTable data={data} columns={notificationListcolumns} />
        </div>
    );
}

const filterRender = (filter, onChange) => {
    return (
        <div style={{position: 'relative', backgroundColor: '#FFFFFF', paddingLeft: '10px'}}>
        <FontAwesomeIcon icon={faSearch}  className='filter-search-icon' />
        <input
        onChange={event => onChange(event.target.value)}
        value={filter ? filter.value : ''}
        style={{
            width: '100%',
            border: '0px'
        }}
        autoComplete='none'
        />
    </div>
    )
}

NotificationList.propTypes = {
    customerData: PropTypes.object.isRequired,
};

export default NotificationList;
